import { useState } from 'react';
import axios from 'axios';
import '../../css/PushManagement/AdminPushCreate.css';

export default function AdminPushForm({ apiBase = 'http://13.124.224.246:7778' }) {
  const [title, setTitle] = useState('');
  const [body, setBody]   = useState('');
  const [loading, setLoading] = useState(false);
  const [result, setResult]   = useState(null);

  const submit = async (e) => {
    e.preventDefault();
    if (!title.trim() || !body.trim()) return alert('제목/내용을 입력하세요');
    setLoading(true);
    try {
      const { data } = await axios.post(`${apiBase}/api/push`, { title, body });
      setResult(data);
      setTitle(''); setBody('');
    } catch (e) {
      alert(e?.response?.data?.message || e.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <form onSubmit={submit} className="push-form">
      <h3>푸시 발송</h3>
      <input
        className="push-input"
        placeholder="제목"
        value={title}
        onChange={e=>setTitle(e.target.value)}
      />
      <textarea
        className="push-textarea"
        placeholder="내용"
        value={body}
        onChange={e=>setBody(e.target.value)}
      />
      <button type="submit" className="push-button" disabled={loading}>
        {loading ? '발송중...' : '발송'}
      </button>
      {result && <pre className="push-result">{JSON.stringify(result, null, 2)}</pre>}
    </form>
  );
}
